import Header from 'components/Dashboard/Header';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { IsLogged } from 'services/authentication';
import { ThemedComponent } from 'ui/theme';
import { Content, DashboardBody, DashboardBodyContent } from './styled';

export default function ContainerAuthenticated({ children }) {
  const { sideOpened, setSideOpened } = useContext(CoreContext);
  const history = useHistory();
  const navigate = useCallback((to) => history.push(`/${to}`), [history]);
  const completeNext = useCallback(() => navigate('login'), [navigate]);
  const init = useCallback(async () => {
    const isLogged = await IsLogged();
    if (!isLogged) {
      completeNext();
    }
  }, [completeNext]);

  useEffect(() => {
    init();
    window.scrollTo(0, 0);
  }, [init]);

  return (
    <ThemedComponent>
      <Content>
        <DashboardBody>
          <Header opened={sideOpened} setOpened={setSideOpened} />
          <DashboardBodyContent opened={sideOpened}>
            {children}
          </DashboardBodyContent>
        </DashboardBody>
      </Content>
    </ThemedComponent>
  );
}
